import React, { FC } from 'react';

import { ABTest } from '@lucid/components-react';

interface ABTestBrandedAAInternalProps {
  willTriggerFire: boolean;
}

const ABTestBrandedAAInternal: FC<ABTestBrandedAAInternalProps> = ({ willTriggerFire = false }) => (
  <ABTest
    isAboveTheFold
    branchesToRender={['T_A', 'T_B']}
    testName="Y23Q3_ChartBrandedAAInternal"
    willTriggerFire={willTriggerFire}
  >
    <ABTest.Branch branch="T_A">{null}</ABTest.Branch>
    <ABTest.Branch branch="T_B">{null}</ABTest.Branch>
  </ABTest>
);

export default ABTestBrandedAAInternal;
